import { useEffect, useState } from 'react';
import * as Popover from '@radix-ui/react-popover';
import { Command, CommandInput } from 'cmdk';

import { cn } from '@components/primitives/utilities';

import { EQLFilterValueList } from './EQLFilterValueList';
import { EQLFilterFieldConfig } from './types';

import css from './styles.module.css';

export interface EQLFilterValueSelectProps {
  value: string | null;
  onValueChange: (value: string) => void;
  field: EQLFilterFieldConfig;
  items: string[];
  defaultOpen?: boolean;
  placeholder?: string;
  className?: string;
}

export function EQLFilterValueSelect({
  value,
  onValueChange,
  field,
  items,
  defaultOpen = false,
  placeholder = 'Search...',
  className,
}: EQLFilterValueSelectProps) {
  const [open, setOpen] = useState(defaultOpen);
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (!open) setSearch('');
  }, [open]);

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger asChild>
        <button
          type="button"
          className={cn(css.segment, css.valueCombobox, className)}
          title={value ?? undefined}
        >
          {value || <span className={css.valuePlaceholder}>unset</span>}
        </button>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content asChild align="start" side="bottom" sideOffset={8}>
          <div className={css.panel}>
            <div className={css.pickerColumn}>
              <Command
                className={css.command}
                loop
                shouldFilter={field.fetchValues !== true}
              >
                <div className={css.searchRow}>
                  <CommandInput
                    autoFocus
                    value={search}
                    onValueChange={setSearch}
                    placeholder={placeholder}
                  />
                </div>

                <EQLFilterValueList
                  field={field}
                  search={search}
                  staticValues={items}
                  selected={value}
                  onSelect={(next) => {
                    onValueChange(next);
                    setOpen(false);
                  }}
                />
              </Command>
            </div>
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
